<header class="page-hero">
  <span class="hero-icon" *ngIf="icone || iconeSrc">
    <mat-icon *ngIf="icone">{{ icone }}</mat-icon>
    <img *ngIf="!icone && iconeSrc" [src]="iconeSrc" [alt]="titulo" />
  </span>

  <div class="hero-texto">
    <h1>
      {{ titulo }}
      <span class="hero-badge" *ngIf="badge !== null && badge !== ''">{{ badge }}</span>
    </h1>
    <p *ngIf="subtitulo">{{ subtitulo }}</p>
  </div>

  <div class="hero-acoes">
    <ng-content></ng-content>
  </div>
</header>
